<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="40%" :offset="0">
      <inquiryInfo :item="item" :right-show="false"></inquiryInfo>
      <div style="text-align: center;" v-if="!isOrder">
        <el-button type="primary" style="margin-top: 10px;" @click="sendInquiry">{{item.isSend==1?'撤回':'发送给客户' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {getBudgetInfo} from '../../js/function'
import inquiryInfo from '../../rightPopup/inquiry/inquiryInfo.vue'
import Api from '@/components/Api/index.js'
export default{
  data(){
    return{
      item:{},
      dialogVisible:false,
      isOrder:false,
    }
  },
  methods:{
    beforeOpen(inquiryId,isSend,isOrder){
      this.dialogVisible = true
      this.isOrder = isOrder
      new Api('plan').inquiryDetail({ inquiryId: inquiryId}).then(res => {
        if (res.status == 200) {
          this.item = res.data
          this.$set(this.item,'isSend',isSend)
        } else {
          this.$message({ type: "error", message: res.statusText })
        }
      })
    },
    sendInquiry(){
      if(this.item.isSend==1){
        new Api('plan').canclePrice({ inquiryId: this.item.inquiryId}).then(res => {
          if (res.status == 200) {
            this.$message({ type: "success", message: "撤回成功" })
            this.$set(this.item,'isSend',0)
            getBudgetInfo(this.$store.state.budgetMainId)
          } else {
            this.$message({ type: "error", message: res.statusText })
          }
        })
      }else{
        new Api('plan').sendPrice({ inquiryId: this.item.inquiryId}).then(res => {
          if (res.status == 200) {
            this.$message({ type: "success", message: "发送成功" })
            this.$set(this.item,'isSend',1)
            getBudgetInfo(this.$store.state.budgetMainId)
          } else {
            this.$message({ type: "error", message: res.statusText })
          }
        })
      }
     
    }
  },
  components:{inquiryInfo}
}
</script>